import { Qr } from '@styled-icons/boxicons-regular/Qr';
import { ResponsivenessWrapper } from '~/components';
import { Footer } from '@getin-widgets/ui';
import { DOWNLOAD_APP_LINK_LINE } from '@getin-widgets/shared/utils/constants';

import * as S from './styles';

export const ModalQrCodeDisabled = () => {
  return (
    <ResponsivenessWrapper>
      <>
        <S.Container>
          <S.Wrapper>
            <S.Header>
              <Qr size={20} />
              <strong>Qr code desabilitado</strong>
            </S.Header>
            <p>
              Está opção foi desabilitada pelo restaurante. Entre em contato com
              à Hostess (recepção) para entrar na fila.{' '}
            </p>
          </S.Wrapper>
        </S.Container>
        <Footer linkDownload={DOWNLOAD_APP_LINK_LINE} />
      </>
    </ResponsivenessWrapper>
  );
};
